module.exports = __webpack_public_path__ + "static/img/shangbiao_17.a00691f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_17.png
// module id = sZX4
// module chunks = 0